import React from 'react'
import { AccordionDetails } from '@mui/material';
import { withStyles } from '@mui/styles';
import { CreditDetail } from '../../../credit-detail';
import { TermInput } from '../../../term-input';


const MuiAccordionDetails = withStyles({
  root: {
    paddingTop: 0,
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column'
  },
})(AccordionDetails)

export const DetailsAccordion: React.FC<{ term: any }> = ({ term }) => {
  return (
    <>
      <MuiAccordionDetails>
        {term.isCalculated ?
          <CreditDetail term={term}></CreditDetail>
          :
          <TermInput />
        }
      </MuiAccordionDetails>
    </>
  )
}
